import StoreCn from './items/StoreCn';
import StoreCommon from './items/StoreCommon';
import { StoreLangTextA } from './StoreLangTextA';
export default function StoreV1({ prefixCls, locale }: { prefixCls: string; locale: string }) {
    const StoreTextA = StoreLangTextA[locale] || StoreLangTextA['us'];

    if (locale === 'global') return null;
    if (locale === 'cn') {
        return <StoreCn prefixCls={prefixCls} locale={locale} />;
    }
    return (
        <>
            <StoreCommon prefixCls={prefixCls} locale={locale} StoreTextA={StoreTextA} />
        </>
    );
}
